import { Parcours } from "../models/Parcours";

export const parcoursBiaisConfirmation: Parcours = {
  id: "parcours-biais-1",
  title: "Comprendre le biais de confirmation",
  description:
    "Ce parcours t'aide a comprendre un mecanisme puissant qui influence tes decisions, a reconnaitre quand il intervient et a t'entrainer a le contourner.",
  audience: "adult",
  level: "intermediate",
  duration: 45,
  goals: [
    "Identifier les situations influencees par le biais",
    "Chercher des informations contradictoires",
    "Observer ses propres croyances avant de decider",
    "Prendre des decisions qui resistent aux contre-arguments",
  ],
  themeIds: ["biais-confirmation"],
  steps: [
    {
      id: "bc_step1",
      type: "micro",
      ref: "bc_mc1",
      title: "Reconnaître le biais",
      description:
        "Avant de changer ton regard, tu dois voir ou le biais s'installe dans ta facon de penser.",
      transition: "Passons a la maniere d'observer autrement.",
    },
    {
      id: "bc_step2",
      type: "micro",
      ref: "bc_mc3",
      title: "Voir ce qu'on ne voulait pas voir",
      description:
        "Chercher la contradiction n'est pas naturel. Mais c'est la que ton esprit devient plus libre.",
      transition: "Tu es pret a regarder tes croyances en face.",
    },
    {
      id: "bc_step3",
      type: "quiz",
      ref: "quiz_biais_confirmation",
      title: "Observer ses propres croyances",
      description:
        "Tu n'es pas neutre : tu regardes le monde a travers ce que tu crois deja. Teste-toi pour le voir.",
      transition: "Mettons cette lucidite en action.",
    },
    {
      id: "bc_step4",
      type: "resource",
      ref: "bc_res_parents",
      title: "Decider avec clarte",
      description:
        "Une bonne decision n'est pas celle qui rassure ton biais, mais celle qui resiste aux contre-arguments.",
      transition: "Conclusion du parcours.",
    },
    {
      id: "step-play-1",
      type: "play",
      ref: "play-parcours-biais-1",
      title: "Mini-jeu : voir tes automatismes",
      description: "Une etape ludique pour observer comment tu selectionnes l'information.",
    },
    {
      id: "step-assist-1",
      type: "assist",
      ref: "assist-parcours-biais-1",
      title: "Reflexion guidee : et toi ?",
      description: "Un temps de prise de recul pour noter ce que tu retiens.",
    },
  ],
};

export const allParcours: Parcours[] = [parcoursBiaisConfirmation];
